"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGenderUnidentified(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 20
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#179FE3",
    d: "M3.512 12.47l-2.33-5.286a1 1 0 011.05-1.394l1.929.265a1 1 0 00.136.009H6.67a1 1 0 00.134-.01l2.37-.32a.42.42 0 01.47.359"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E568B2",
    d: "M7.796 8.207l2.01 3.88a1 1 0 01-.888 1.46H8.14a1 1 0 00-1 1v2.77a1 1 0 01-1 1H4.972a1 1 0 01-1-1v-2.802a1 1 0 00-1-1h-.504"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.614,
    cy: 2.159,
    r: 2.159,
    stroke: "#179FE3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C5CC",
    d: "M.437 14.839l9.9-9.9.706.708-9.899 9.899z"
  })));
}

var MemoSvgGenderUnidentified = /*#__PURE__*/React.memo(SvgGenderUnidentified);
var _default = MemoSvgGenderUnidentified;
exports["default"] = _default;